/* eslint-disable react/prop-types */
import PropTypes from 'prop-types';
import { useIntl } from 'gatsby-plugin-react-intl';
import { graphql } from 'gatsby';

import Layout from '../../Components/Core/Layout';
import SEO from '../../Components/Core/Seo';
import BackToTop from '../../Components/Core/BackToTop';
import PageBuilder from '../../Components/Core/PageBuilder';
import CampaignOptimumBanner from '../../Components/Custom/Banners/CampaignOptimumBanner';
import OptimumPointCounter from '../../Components/Custom/Optimum/OptimumPointCounter';
import OptimumStoresBanner from '../../Components/Custom/Optimum/OptimumStoresBanner';
import OptimumPointRoller from '../../Components/Custom/Optimum/OptimumPointRoller';
import PCMoneyCDIC from '../../Components/Screens/CDIC/PCMoneyCDIC';
import {
  heroBanner,
  containerSection,
  statementSection,
  faqBlock,
  faqPopularQuestion,
  proTip,
  titleOrImageWithIconLists,
  chart,
  legal,
  calculator,
  appBanner,
  gallery,
  simpleBanner,
  videos,
} from '../../utils/variation';
// import AnimatedInteractiveModel from '../../Components/Custom/Animated/AnimatedInteractiveModel';
// import AnimatedSlidingCoverHero from '../../Components/Custom/Animated/AnimatedSlidingCoverHero';
// import OptimumPointCircleBanner from '../../Components/Custom/Optimum/OptimumPointCircleBanner';
// import PCXBanner from '../../Components/Screens/Banners/PCX';

const pageTemplate = {
  ...heroBanner,
  'pc-optimum-campaign-banner': CampaignOptimumBanner,
  'secondary-campaign-banner': CampaignOptimumBanner,
  ...titleOrImageWithIconLists,
  'optimum-points-roller': OptimumPointRoller,
  'optimum-billion-points-counter': OptimumPointCounter,
  'pc-optimum-store-banner': OptimumStoresBanner,
  'pc-optimum-store-accordion': OptimumStoresBanner,
  ...videos,
  ...chart,
  ...calculator,
  ...legal,
  ...appBanner,
  'cdic-banner': PCMoneyCDIC,
  ...appBanner,
  ...containerSection,
  ...statementSection,
  ...faqPopularQuestion,
  ...faqBlock,
  ...proTip,
  ...gallery,
  ...simpleBanner,
  // 'pcx-banner': PCXBanner, unused
  // 'earn-optimum-points': OptimumPointCircleBanner, unused
  // '3d-model': AnimatedInteractiveModel, unused
  // 'animated-sliding-cover': AnimatedSlidingCoverHero, unused
};

const CampaignPageTemplate = ({ location, data }) => {
  const {
    contentfulCampaignPageLayout: {
      pageTitle,
      metaDescription,
      languageToggle,
      displayInSiteMap,
      promoCode,
      customHeader,
      sections,
      customFooter,
      pageSlug,
      internal: { type },
    },
  } = data;
  const intl = useIntl();
  return (
    <Layout
      location={location}
      header={customHeader}
      footer={customFooter}
      languageToggle={languageToggle}
      promoCode={promoCode}
      contentType={type}
    >
      <SEO
        title={pageTitle}
        description={metaDescription}
        lang={intl.locale}
        location={location}
        noIndex={displayInSiteMap}
      />
      <PageBuilder
        sections={sections}
        template={pageTemplate}
        pageSlug={pageSlug}
      />
      <BackToTop />
    </Layout>
  );
};

CampaignPageTemplate.propTypes = {
  data: PropTypes.shape().isRequired,
  location: PropTypes.shape().isRequired,
};

export const query = graphql`
  query CampaignPage($locale: String = "en-CA", $contentful_id: String!) {
    contentfulCampaignPageLayout(
      contentful_id: { eq: $contentful_id }
      node_locale: { eq: $locale }
    ) {
      id
      contentful_id
      node_locale
      pageSlug
      pageTitle
      metaDescription
      languageToggle
      displayInSiteMap
      promoCode
      internal {
        type
      }
      ...global_campaign_header
      sections {
        ...hero_banner
        ...statement_section
        ...app_banner_stepper
        ...app_banner
        ...faq_popular_question
        ...section_container
        ...legal_details
        ...optimum_stores_banner
        ...simple_image_banner
        ...calculator
        ...ticker_section
        ...product_chart
        ...titleOrImageWithIconLists
        ...pro_tip
        ...gallery
        ...video_item
      }
      ...global_campaign_footer
    }
  }
`;

export default CampaignPageTemplate;

export const Head = ({ location, data, pageContext }) => {
  return (
    <SEO
      data={data.contentfulCampaignPageLayout}
      pageContext={pageContext}
      location={location}
    />
  );
};
